import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import speed1 from './pictures/speed1.JPG';
import speed2 from './pictures/speed2.JPG';
import speed3 from './pictures/speed3.JPG';

const Speed = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC Speed Friending!</h2>
                    <p class="site-post-meta">November 21st, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
    
                    On November 14th, we had our Speed Friending event! 

                    Thank you so much to everyone who played some icebreaker games with us and enjoyed some brownies 

                    Hope to see everyone at our future events and continue builing a great community! 

                    </p>
                    <img src={speed1} alt="pic1 "/>
                    <img src={speed2} alt="pic2"/>
                    <img src={speed3} alt="pic3"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Speed;
